export enum NavigationFeatureFlags {
  CREATE_PROFILE = 'CREATE_PROFILE',
  ADD_SNAPSHOT_LOCATION = 'ADD_SNAPSHOT_LOCATION',
  ADD_EVENT_LOCATION = 'ADD_EVENT_LOCATION',
  SURVEYS = 'SURVEYS',
}
